import { Trash2 } from 'lucide-react';
import { Button } from '@/components/Button';
import { Dialog, DialogButtonGroup, DialogClose } from '@/components/Dialog';
import { Icon } from '@/components/Icon';
import { EmbeddedDangerToast } from '@/components/Toasts';
import * as styles from './index.css';

type DeleteTarget = {
    name: string;
};

type DeleteUserDialogProps = {
    target: DeleteTarget | null;
    isSubmitting: boolean;
    onOpenChange: (open: boolean) => void;
    onSubmit: () => Promise<void>;
};

export function DeleteUserDialog({ target, isSubmitting: isPending, onOpenChange, onSubmit }: DeleteUserDialogProps) {
    return (
        <Dialog title="ユーザーを削除する" open={target !== null} onOpenChange={onOpenChange}>
            <EmbeddedDangerToast title="削除のご注意お願いします" message="削除すると元に戻せません。" />
            <p>
                <strong className={styles.deleteTargetUser}>{target?.name}</strong>{' '}
                を削除しますか？この操作は元に戻せません。
            </p>

            <DialogButtonGroup>
                <DialogClose>
                    <Button type="button" variant="secondary">
                        キャンセル
                    </Button>
                </DialogClose>

                <Button type="button" variant="danger" onClick={onSubmit} disabled={isPending}>
                    {isPending ? (
                        '削除中...'
                    ) : (
                        <>
                            <Icon icon={Trash2} size="sm" />
                            <span>削除する</span>
                        </>
                    )}
                </Button>
            </DialogButtonGroup>
        </Dialog>
    );
}
